import { Button } from "antd";
import { YhBox } from "@/components/YhBox";
import { DetailActionTypeEnum, useDetailModel } from "./detailModel";

export const InfoBox = () => {

    const {
        actionType, title,
        setActionType,
    } = useDetailModel();

    const classname = (type: DetailActionTypeEnum) => {
        return 'tab-item ' + (actionType === type ? 'tab-active' : '')
    }

    const action = (
        <>
            <div>
                <Button
                    className={classname(DetailActionTypeEnum.ACCOUNT)}
                    type="link"
                    shape="round"
                    onClick={() => setActionType(DetailActionTypeEnum.ACCOUNT)}>
                    月结账户信息
                </Button>
                <Button
                    className={classname(DetailActionTypeEnum.OPEN)}
                    type="link"
                    shape="round"
                    onClick={() => setActionType(DetailActionTypeEnum.OPEN)}>
                    月结开户记录
                </Button>
                <Button
                    className={classname(DetailActionTypeEnum.ADJUST)}
                    type="link"
                    shape="round"
                    onClick={() => setActionType(DetailActionTypeEnum.ADJUST)}>
                    调额记录
                </Button>
                <Button
                    className={classname(DetailActionTypeEnum.RECHARGE)}
                    type="link"
                    shape="round"
                    onClick={() => setActionType(DetailActionTypeEnum.RECHARGE)}>
                    充值记录
                </Button>
                <Button
                    className={classname(DetailActionTypeEnum.CONTRACT)}
                    type="link"
                    shape="round"
                    onClick={() => setActionType(DetailActionTypeEnum.CONTRACT)}>
                    合约详情
                </Button>
                <Button
                    className={classname(DetailActionTypeEnum.STATEMENT)}
                    type="link"
                    shape="round"
                    onClick={() => setActionType(DetailActionTypeEnum.STATEMENT)}>
                    对账单
                </Button>
                <Button
                    className={classname(DetailActionTypeEnum.BILL)}
                    type="link"
                    shape="round"
                    onClick={() => setActionType(DetailActionTypeEnum.BILL)}>
                    账单
                </Button>
            </div>
        </>
    );
    return (
        <YhBox
            title={title}
            action={action}
        />
    )
}
